// $(document).ready(function () {
//     $('.creative-story__play-icon').on('click', function () {
//         let videoUrl = $(this).attr('data-att');
//         let videoId = '';
//         if (videoUrl.includes('youtu.be/')) {
//             videoId = videoUrl.split('youtu.be/')[1].split('?')[0];
//         } else if (videoUrl.includes('watch?v=')) {
//             videoId = videoUrl.split('watch?v=')[1].split('&')[0];
//         }
//         let embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
//         $('.modal__video iframe').attr('src', embedUrl);
//         $('body').addClass('modal-open');
//         $('.modal-bg').fadeIn(300);
//     });
//     $('.modal__close, .modal-bg').on('click', function () {
//         $('body').removeClass('modal-open');
//         $('.modal-bg').fadeOut(300);
//         $('.modal__video iframe').attr('src', '');
//     });
// });


document.addEventListener('click', function (e) {

  // Open modal
  const playBtn = e.target.closest('.creative-story__play-icon');

  if (playBtn) {
    console.log('clicked');

    const videoUrl = playBtn.getAttribute('data-att');
    let videoId = '';

    if (videoUrl.includes('youtu.be/')) {
      videoId = videoUrl.split('youtu.be/')[1].split('?')[0];
    } else if (videoUrl.includes('watch?v=')) {
      videoId = videoUrl.split('watch?v=')[1].split('&')[0];
    }

    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

    document.querySelector('.modal__video iframe').src = embedUrl;

    document.body.classList.add('modal-open');

    const modalBg = document.querySelector('.modal-bg');
    modalBg.style.display = 'block';

    setTimeout(() => {
      modalBg.style.opacity = '1';
    }, 10);
  }

  // Close modal
  if (
    e.target.closest('.modal__close') ||
    e.target.classList.contains('modal-bg')
  ) {
    document.body.classList.remove('modal-open');

    const modalBg = document.querySelector('.modal-bg');

    modalBg.style.opacity = '0';

    setTimeout(() => {
      modalBg.style.display = 'none';
    }, 300);

    document.querySelector('.modal__video iframe').src = '';
  }

});